<div class="not-found-container">
  <div class="not-found-card">
    <div class="error-code">
      <span class="four">4</span>
      <span class="zero">
        <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
          <circle cx="50" cy="50" r="40" />
        </svg>
      </span>
      <span class="four">4</span>
    </div>

    <h1 class="title">Page Not Found</h1>
    <p class="subtitle">
      The page you're looking for doesn't exist or has been moved.
    </p>

    <div class="actions">
      <button class="btn btn-primary" (click)="goHome()">
        <span class="btn-icon">&#8962;</span> Go Home
      </button>
      <button class="btn btn-secondary" (click)="goBack()">
        <span class="btn-icon">&#8592;</span> Go Back
      </button>
    </div>
  </div>
</div>
